import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import DashboardListCard from 'modules/common/dashboard/DashboardListCard';
import RptbDashboardContainer from './containers/RptbDashboardContainer';
import CmsContext from '../../../context/CmsContext';
import * as actions from './action';
import * as c from './constant';

function TransactionsContainer({ totalStats, getTotalStats }) {
  const cmsContext = useContext(CmsContext);
  const CMS_VARIABLES = cmsContext.findByType('VARIABLES')


  const returnTaxPaymentBoronganData = () => {
    const data = _.get(totalStats, 'item.TYPES.CURRENT.total_per_status');
    return {
      label: 'Tax Payment',
      total: _.get(totalStats, 'item.TYPES.CURRENT.total', 0),
      // photo: ''
      list: [
        { label: 'Draft', value: _.get(data, 'DRAFT', 0), borderClassName: 'pickup' },
        { label: 'Pending', value: _.get(data, 'PENDING', 0), borderClassName: 'waiting' },
        { label: 'Waiting for Payment', value: _.get(data, 'WAITING FOR PAYMENT', 0), borderClassName: 'waiting' },
        { label: 'Expired Reference Number', value: _.get(data, 'EXPIRED REFERENCE NUMBER', 0), borderClassName: 'received' },
        { label: 'Paid', value: _.get(data, 'PAID', 0), borderClassName: 'paid' },
      ],
    }
  };

  const returnTaxPaymentData = () => {
    const data = _.get(totalStats, 'item.TYPES.TAX PAYMENT.total_per_status');
    return {
      label: 'Tax Payment',
      total: _.get(totalStats, 'item.TYPES.TAX PAYMENT.total', 0),
      // photo: ''
      list: [
        { label: 'Cancelled', value: _.get(data, 'CANCELLED', 0), borderClassName: 'pickup' },
        { label: 'Expired Reference Number', value: _.get(data, 'EXPIRED REFERENCE NUMBER', 0), borderClassName: 'received' },
        { label: 'Pending', value: _.get(data, 'PENDING', 0), borderClassName: 'waiting' },
        { label: 'Paid', value: _.get(data, 'PAID', 0), borderClassName: 'paid' },
      ],
    }
  };

  const returnTaxClearanceData = () => {
    const data = _.get(totalStats, 'item.TYPES.TAX CLEARANCE.total_per_status');
    return {
      label: 'Tax Clearance',
      total: _.get(totalStats, 'item.TYPES.TAX CLEARANCE.total', 0),
      // photo: ''
      list: [
        { label: 'For Checking', value: _.get(data, 'FOR CHECKING', 0), borderClassName: 'waiting' },
        { label: 'For Resubmission', value: _.get(data, 'FOR RESUBMISSION', 0), borderClassName: 'waiting' },
        { label: 'Pending', value: _.get(data, 'PENDING', 0), borderClassName: 'waiting' },
        { label: 'Waiting for Payment', value: _.get(data, 'WAITING FOR PAYMENT', 0), borderClassName: 'waiting' },
        { label: 'Expired Reference Number', value: _.get(data, 'EXPIRED REFERENCE NUMBER', 0), borderClassName: 'received' },
        { label: 'Paid', value: _.get(data, 'PAID', 0), borderClassName: 'paid' },
      ],
    }
  };

  useEffect(() => {
    getTotalStats();
  }, []);

  return (
    <div className="container-fluid mb-3 pt-4">
      <div className="row">
        <div className="col-4 pl-0">
          {(_.get(CMS_VARIABLES, 'LGU_NAME') !== 'City of Borongan') && (
            <DashboardListCard data={returnTaxPaymentData()} className="mb-3" />
          )}
          {(_.get(CMS_VARIABLES, 'LGU_NAME') === 'City of Borongan') && (
            <DashboardListCard data={returnTaxPaymentBoronganData()} />
          )}
          {['City of Borongan', 'Las Piñas'].indexOf(_.get(CMS_VARIABLES, 'LGU_NAME')) === -1 && (
            <DashboardListCard data={returnTaxClearanceData()} />
          )}
        </div>
        <div className="col-8 pr-0">
          <RptbDashboardContainer />
        </div>
      </div>
    </div>
  );
}

TransactionsContainer.propTypes = {
  totalStats: PropTypes.instanceOf(Object).isRequired,
  getTotalStats: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  totalStats: _.get(api, `${c.GET_TOTAL_STATS}`) || {},
});

const enhance = _.flowRight([
  withRouter,
  connect(mapStateToProps, actions),
]);

export default enhance(TransactionsContainer);
